export const DEFAULT_COLLECTIONS = {
  ALL_HIDDEN: {
    key: 'ALL_HIDDEN',
    label: 'All Passed',
  },
  ALL_STARRED: {
    key: 'ALL_STARRED',
    label: 'All Qualified',
  },
  ALL_WATCHED: {
    key: 'ALL_WATCHED',
    label: 'All Monitoring',
  },
};
